<template>
    <div class="user-box">
        <div class="user-list">
            <div class="user-list-left ">头像</div>
            <div class="user-list-right">
                <img :src="userinfo.avatar" alt="">
            </div>
        </div>
        <div class="user-list border-top">
            <div class="user-list-left ">昵称</div>
            <div class="user-list-right after-jt font-65">{{userinfo.nickname}}</div>
        </div>
        <div class="user-list border-top">
            <div class="user-list-left ">手机号</div>
            <div class="user-list-right after-jt font-65">{{userinfo.mobile}}</div>
        </div>
    </div>
</template>
<script>
import http from "../../request/http";

export default {
    data(){
      return {
        userinfo:{}
      }
    },
    mounted() {
      this.myinfo()
    },
    methods:{
      myinfo(){
        http.post('/api/wap/user/myinfo').then(res=>{
          this.userinfo = res.data;
        })
      }
    }
}
</script>
<style lang="css" scoped>
    @import './edit.css';
</style>



// WEBPACK FOOTER //
// src/pages/user/user_edit.vue